export const displayTitleMap: Record<string, string[]> = {
  'b_01.01': [
    '0050 - Competent Authority',
    'entity_id',
    '0020 - Name of the financial entity',
    '0040 - Type of entity',
    '0030 - Country of the entity',
    '0010 - LEI of the financial entity maintaining the register of information',
    '0060 - Date of the reporting',
  ],
  'b_01.02': [
    '0030 - Country of the financial entity',
    '0100 - Currency',
    '0070 - Date of last update',
    '0090 - Date of deletion in the Register of information',
    'entity id',
    '0020 - Name of the entity',
    '0040 - Type of financial entity',
    '0050 - Hierarchy of the financial entity within the group (where applicable)',
    '0080 - Date of integration in the Register of information',
    '0010 - LEI of the financial entity',
    '0060 - LEI of the direct parent undertaking of the entity',
    '0110 - Value of total assets of the financial entity',
  ],
  'b_01.03': [
    '0010 - Identification code of the branch',
    '0030 - Name of the branch',
    '0040 - Country of the branch',
    'entity id',
    'entity name',
    '0020 - LEI of the financial entity head office of the branch',
  ],

  'b_02.01': [
    '0050 - Annual expense or estimated cost of the contractual arrangement for the past year',
    '0010 - Contractual arrangement reference number',
    '0020 - Type of contractual arrangement',
    '0040 - Currency of the amount reported in B.02.01.0050',
    'entity_id',
    'entity_name',
    '0030 - Overarching contractual arrangement reference number',
  ],
  'b_02.02': [
    '0010 - Contractual arrangement reference number',
    '0130 - Country of provision of the ICT services',
    '0160 - Location of management of the data (processing)',
    '0150 - Location of the data at rest (storage)',
    '0170 - Sensitiveness of the data stored by the ICT third-party service provider',
    '0080 - End date of the contractual arrangement',
    'entity id',
    'entity name',
    '0100 - Notice period for the financial entity making use of the ICT service(s)',
    '0050 - Function identifier',
    '0120 - Country of the governing law of the contractual arrangement',
    '0030 - Identification code of the ICT third-party service provider',
    '0060 - Type of ICT services',
    '0020 - LEI of the financial entity making use of the ICT service(s)',
    '0180 - Level of reliance on the ICT service supporting the critical or important function',
    '0040 - Type of code to identify the ICT third-party service provider',
    '0110 - Notice period for the ICT third-party service provider',
    '0070 - Start date of the contractual arrangement',
    '0140 - Storage of data',
    '0090 - Reason of the termination or ending of the contractual arrangement',
  ],
  'b_02.03': [
    '0010 - Contractual arrangement reference number',
    'entity_id',
    'entity_name',
    '0020 - Contractual arrangement linked to the contractual arrangement referred in B.02.03.0010',
  ],
  'b_03.01': [
    '0010 - Contractual arrangement reference number',
    '0020 - LEI of the entity signing the contractual arrangement',
  ],
  'b_03.02': [
    '0010 - Contractual arrangement reference number',
    'entity_id',
    'entity_name',
    '0020 - Identification code of ICT third-party service provider',
    '0030 - Type of code to identify the ICT third-party service provider',
  ],
  'b_03.03': [
    '0010 - Contractual arrangement reference number',
    'entity_id',
    'entity_name',
    '0020 - LEI of the financial entity providing ICT services',
  ],
  'b_04.01': [
    '0010 - Contractual arrangement reference number',
    '0040 - Identification code of the branch',
    'entity_id',
    'entity_name',
    '0020 - LEI of the financial entity making use of the ICT service(s)',
    '0030 - Nature of the financial entity making use of the ICT service(s)',
  ],
  'b_05.01': [
    '0030 - Additional identification code of ICT third-party service provider',
    '0080 - Country of the ICT third-party service provider’s headquarters',
    '0010 - Identification code of ICT third-party service provider',
    '0050 - Legal name of the ICT third- party service provider',
    '0060 - Name of the ICT third-party service provider in Latin alphabet',
    '0090 - Currency of the amount reported in RT.05.01.0070',
    '0100 - Total annual expense or estimated cost of the ICT third-party service provider',
    '0020 - Type of code to identify the ICT third-party service provider',
    '0040 - Type of additional identification code of the ICT third-party service provider',
    '0070 - Type of person of the ICT third-party service provider',
    '0120 - Type of code to identify the ICT third-party service provider’s ultimate parent undertaking',
    '0110 - Identification code of the ICT third-party service provider’s ultimate parent undertaking',
    'entity_id',
    'entity_name',
  ],
  'b_05.02': [
    '0010 - Contractual arrangement reference number',
    '0030 - Identification code of the ICT third-party service provider',
    '0050 - Rank',
    '0060 - Identification code of the recipient of sub-contracted ICT services',
    '0070 - Type of code to identify the recipient of sub-contracted ICT services',
    '0040 - Type of code to identify the ICT third-party service provider',
    '0020 - Type of ICT services',
    'entity_id',
    'entity_name',
  ],
  'b_06.01': [
    '0050 - Criticality or importance assessment',
    '0070 - Date of the last assessment of criticality or importance',
    '0010 - Function Identifier',
    '0030 - Function name',
    '0100 - Impact of discontinuing the function',
    '0040 - LEI of the financial entity',
    '0020 - Licenced activity',
    '0060 - Reasons for criticality or importance',
    '0090 - Recovery point objective of the function',
    '0080 - Recovery time objective of the function',
    'entity_id',
    'entity_name',
  ],
  'b_07.01': [
    '0120 - Identification of alternative ICT TPP',
    '0110 - Are there alternative ICT third-party service providers identified?',
    '0010 - Contractual arrangement reference number',
    '0070 - Date of the last audit on the ICT third-party service provider',
    '0080 - Existence of an exit plan',
    '0020 - Identification code of the ICT third-party service provider',
    '0100 - Impact of discontinuing the ICT services',
    '0060 - Reason if the ICT third-party service provider is considered not substitutable or difficult to be substitutable',
    '0090 - Possibility of reintegration of the contracted ICT service',
    '0050 - Substitutability of the ICT third-party service provider',
    '0030 - Type of code to identify the ICT third-party service provider',
    '0040 - Type of ICT services',
    'entity_id',
    'entity_name',
  ],
};
